<template>
  <div class="page-container">
    <div class="container">
      <div class="date-picker-container">
        <el-date-picker
          v-model="selectedDate"
          type="date"
          placeholder="选择日期"
          @change="onDateChange">
        </el-date-picker>
      </div>
      
      <!-- 匹配结果表格 -->
      <div class="match-result-container">
        <h3>匹配结果表格</h3>
        <el-table
          :data="matchResultData"
          border
          style="width: 100%;">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="carNumber" label="车号" width="80"></el-table-column>
          <el-table-column property="driverName" label="司机姓名" width="90"></el-table-column>
          <el-table-column property="productName" label="产品名称" width="110"></el-table-column>
          <!-- 数量列：拼接数量和单位 -->
          <el-table-column label="数量" width="100">
            <template slot-scope="scope">
              {{ scope.row.quantity }} {{ scope.row.productUnit }}
            </template>
          </el-table-column>
          <el-table-column property="addr" label="地址" min-width="180"></el-table-column>
          <el-table-column property="ownerName" label="货主" width="90"></el-table-column>
          <el-table-column property="ground" label="场地" width="90"></el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-button 
                type="danger" 
                size="mini"
                @click="handleUnmatch(scope.row)">
                取消匹配
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="dual-table-container">
        <div class="table-wrapper">
          <h3>出货表格</h3>
          <el-table
            ref="exportTable"
            :data="exportData"
            highlight-current-row
            @current-change="handleExportCurrentChange"
            border
            style="width: 100%;">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column property="carNumber" label="车号" width="80"></el-table-column>
            <el-table-column property="productName" label="产品名称" width="110"></el-table-column>
            <!-- 数量列：拼接数量和单位 -->
            <el-table-column label="数量" width="100">
              <template slot-scope="scope">
                {{ scope.row.quantity }} {{ scope.row.productUnit }}
              </template>
            </el-table-column>
            <el-table-column property="addr" label="地址" min-width="180"></el-table-column>
            <el-table-column property="groundName" label="场地" width="90"></el-table-column>
          </el-table>
        </div>

        <div class="button-container">
          <el-button
            type="success"
            :loading="autoMatching"
            @click="handleAutoMatch"
            size="small">
            自动匹配
          </el-button>
          <div style="height: 10px;"></div>
          <el-button
            type="primary"
            :disabled="!currentExportRow || !currentOrderRow"
            @click="handleMatch"
            size="small">
            匹配
          </el-button>
        </div>

        <div class="table-wrapper">
          <h3>班产表</h3>
          <el-table
            ref="orderTable"
            :data="orderData"
            highlight-current-row
            @current-change="handleOrderCurrentChange"
            border
            style="width: 100%;">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column property="carNumber" label="车号" width="80"></el-table-column>
            <el-table-column property="productName" label="产品名称" width="110"></el-table-column>
            <!-- 数量列：拼接数量和单位 -->
            <el-table-column label="数量" width="100">
              <template slot-scope="scope">
                {{ scope.row.quantity }} {{ scope.row.productUnit }}
              </template>
            </el-table-column>
            <el-table-column property="addr" label="地址" min-width="180"></el-table-column>
            <el-table-column property="groundName" label="场地" width="90"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  data() {
    return {
      exportData: [],
      orderData: [],
      matchResultData: [],
      currentExportRow: null,
      currentOrderRow: null,
      loading: false,
      error: null,
      selectedDate: new Date(),
      autoMatching: false,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      
      this.exportData = [];
      this.orderData = [];
      this.matchResultData = [];
      this.currentExportRow = null;
      this.currentOrderRow = null;
      
      try {
        const formattedDate = this.formatDate(this.selectedDate);
        
        // 1. 获取Export和Order数据
        const mainOptions = {
          method: 'GET',
          url: '/admin/match/getMatchInfo',
          params: { date: formattedDate }
        };
        
        const mainResponse = await adminrequest.request(mainOptions);
        
        if (mainResponse.data.code === 200) {
          this.exportData = mainResponse.data.data.export || [];
          this.orderData = mainResponse.data.data.order || [];
        } else {
          this.error = `请求主数据失败: ${mainResponse.data.message}`;
          this.$message.error(this.error);
        }
        
        // 2. 获取匹配结果数据
        const matchOptions = {
          method: 'GET',
          url: '/admin/match/getMatched',
          params: { date: formattedDate }
        };
        
        const matchResponse = await adminrequest.request(matchOptions);
        
        if (matchResponse.data.code === 200) {
          this.matchResultData = matchResponse.data.data || [];
        } else {
          this.error = `请求匹配结果失败: ${matchResponse.data.message}`;
          this.$message.error(this.error);
        }
        
        // 检查是否所有数据都为空
        if (this.exportData.length === 0 && this.orderData.length === 0 && this.matchResultData.length === 0) {
          this.$message.info('所选日期没有数据');
        }
      } catch (error) {
        this.error = `网络错误: ${error.message}`;
        this.$message.error(this.error);
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
    
    onDateChange(date) {
      this.selectedDate = date;
      this.fetchData();
    },

    handleExportCurrentChange(val) {
      this.currentExportRow = val;
    },

    handleOrderCurrentChange(val) {
      this.currentOrderRow = val;
    },

    // 手动匹配方法
    async handleMatch() {
      if (!this.currentExportRow || !this.currentOrderRow) {
        this.$message.warning('请先分别选择Export和Order表格中的行');
        return;
      }
    
      try {
        // 1. 验证参数有效性
        if (!this.currentExportRow.itemId || !this.currentOrderRow.itemId || !this.selectedDate) {
          this.$message.error('参数不完整，请检查数据');
          return;
        }
    
        // 2. 创建FormData并转换参数为字符串
        const form = new FormData();
        form.append("exportItemId", String(this.currentExportRow.itemId));
        form.append("orderItemId", String(this.currentOrderRow.itemId));
        form.append("date", this.formatDate(this.selectedDate));
    
        // 3. 修正请求路径，补充/admin前缀
        const options = {
          method: 'POST',
          url: '/admin/match/match', // 完整路径对应：http://localhost:8083/admin/match/match
          data: form,
          headers: {
            'content-type': 'multipart/form-data' // 显式声明表单类型（可选，浏览器会自动处理）
          }
        };
    
        const response = await adminrequest.request(options);
    
        if (response.data.code === 200) {
          this.$message.success('匹配成功');
          this.fetchData();
        } else {
          this.$message.error(`匹配失败: ${response.data.message}`);
        }
      } catch (error) {
        this.$message.error(`网络错误: ${error.message}`);
        console.error(error);
      }
    },
    
    // 自动匹配方法
    async handleAutoMatch() {
      if (this.exportData.length === 0 || this.orderData.length === 0) {
        this.$message.warning('Export或Order表格数据为空，无法进行自动匹配');
        return;
      }
    
      // 新增日期参数校验
      if (!this.selectedDate) {
        this.$message.error('请选择匹配日期');
        return;
      }
    
      this.autoMatching = true;
      
      try {
        // 1. 创建FormData并转换参数为字符串
        const form = new FormData();
        form.append("date", String(this.formatDate(this.selectedDate))); // 确保日期为字符串格式
        
        // 2. 修正请求路径，补充/admin前缀
        const options = {
          method: 'POST',
          url: '/admin/match/autoMatch', // 完整路径对应：http://localhost:8083/admin/match/autoMatch
          data: form,
          headers: {
            'content-type': 'multipart/form-data' // 显式声明表单类型（可选）
          }
        };
    
        const response = await adminrequest.request(options);
    
        if (response.data.code === 200) {
          const matchedCount = response.data.data || 0;
          this.$message.success(`自动匹配完成，成功匹配 ${matchedCount} 条记录`);
          this.fetchData();
        } else {
          this.$message.error(`自动匹配失败: ${response.data.message}`);
        }
      } catch (error) {
        this.$message.error(`网络错误: ${error.message}`);
        console.error(error);
      } finally {
        this.autoMatching = false;
      }
    },
    
    async handleUnmatch(row) {
      try {
        // 1. 验证参数是否存在（避免传递空值）
        if (!row?.matchId || !row?.exportItem || !row?.orderItem) {
          this.$message.error('参数不完整，请检查数据');
          return;
        }
    
        // 2. 创建FormData并添加参数（确保参数为字符串类型，与第一段代码一致）
        const form = new FormData();
        form.append("matchId", String(row.matchId));  // 转为字符串，与示例中"5"格式一致
        form.append("exportItem", String(row.exportItem));
        form.append("orderItem", String(row.orderItem));
        
        // 3. 修正请求路径，与第一段代码的完整路径匹配
        const options = {
          method: 'POST',
          url: '/admin/match/unmatch',  // 补充/admin前缀，确保路径为/admin/match/unmatch
          data: form,
          // 4. 无需手动设置Content-Type，浏览器会自动处理（与示例效果一致）
          headers: {
            'content-type': 'multipart/form-data'  // 可选：显式声明类型（浏览器会自动补充boundary）
          }
        };
    
        const response = await adminrequest.request(options);
    
        if (response.data.code === 200) {
          this.$message.success('取消匹配成功');
          this.fetchData();
        } else {
          this.$message.error(`取消匹配失败: ${response.data.message}`);
        }
      } catch (error) {
        this.$message.error(`网络错误: ${error.message}`);
        console.error(error);
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  /* 页面容器，用于填充整个页面宽度 */
  width: 100%;
  padding: 0 15px; /* 两侧留小间距，避免内容贴边 */
  box-sizing: border-box;
}

.container {
  /* 内容容器，限制最大宽度并居中 */
  max-width: 1600px; /* 根据实际需求调整 */
  margin: 0 auto; /* 水平居中 */
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.date-picker-container {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.match-result-container {
  margin-bottom: 20px;
}

.dual-table-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding-bottom: 10px;
  width: 100%;
}

.table-wrapper {
  flex: 1;
  min-width: 0; /* 允许flex子元素收缩到内容宽度 */
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-top: 20px;
}

.button-container .el-button {
  padding: 8px 16px;
  font-size: 14px;
  min-width: 100px;
}

/* 确保表格内容不换行，保持在一行显示 */
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 表格宽度自适应容器 */
.el-table {
  width: 100% !important;
}
</style>